const VIEWABLE_MIME_TYPES = new Set([
    "application/pdf",
    "image/png",
    "image/jpeg",
    "image/jpg",
]);

const base64ToArrayBuffer = (base64: string) => {
    const binaryString = window.atob(base64);
    const len = binaryString.length;
    const bytes = new Uint8Array(len);
    for (let i = 0; i < len; i++) {
        bytes[i] = binaryString.charCodeAt(i);
    }
    return bytes.buffer;
};

const downloadFile = (fileContent: string, fileName: string) => {
    const link = document.createElement('a');
    document.body.appendChild(link);
    link.href = 'data:application/octet-stream;base64,' + fileContent;
    link.download = fileName;
    link.click();
    document.body.removeChild(link);
};

const openDocumentModal = (url: string, mimeType: string) => {
    const overlay = document.createElement('div');
    overlay.style.cssText = `
        position: fixed; inset: 0;
        background: rgba(0,0,0,0.7);
        z-index: 9999;
        display: flex;
        align-items: center;
        justify-content: center;
    `;

    const modal = document.createElement('div');
    modal.style.cssText = `
        background: white;
        border-radius: 8px;
        width: 90vw;
        height: 90vh;
        display: flex;
        flex-direction: column;
        overflow: hidden;
    `;

    const header = document.createElement('div');
    header.style.cssText = `
        display: flex;
        justify-content: flex-end;
        padding: 8px 12px;
        border-bottom: 1px solid #e5e7eb;
    `;

    const closeBtn = document.createElement('button');
    closeBtn.textContent = '✕ Fechar';
    closeBtn.style.cssText = `
        cursor: pointer;
        padding: 4px 12px;
        border: 1px solid #d1d5db;
        border-radius: 4px;
        background: white;
        font-size: 14px;
    `;

    const close = () => {
        document.body.removeChild(overlay);
        URL.revokeObjectURL(url);
    };

    closeBtn.addEventListener('click', close);
    overlay.addEventListener('click', (e) => {
        if (e.target === overlay) close();
    });

    // Imagens renderizam com <img>, PDF com <iframe>
    const isImage = mimeType.startsWith('image/');

    if (isImage) {
        const img = document.createElement('img');
        img.src = url;
        img.style.cssText = `
            flex: 1;
            width: 100%;
            height: 100%;
            object-fit: contain;
            padding: 16px;
            box-sizing: border-box;
        `;
        header.appendChild(closeBtn);
        modal.appendChild(header);
        modal.appendChild(img);
    } else {
        const iframe = document.createElement('iframe');
        iframe.src = url;
        iframe.style.cssText = `
            flex: 1;
            width: 100%;
            border: none;
        `;
        header.appendChild(closeBtn);
        modal.appendChild(header);
        modal.appendChild(iframe);
    }

    overlay.appendChild(modal);
    document.body.appendChild(overlay);
};

export const handleViewDocument = async (uid_documento: string, fetchDocService: Function) => {
    try {
        const data = await fetchDocService(uid_documento);
        const { mimeType, fileContent, doc_titulo, fileExtension } = data;

        // Se o tipo não é visualizável, faz download direto
        if (!VIEWABLE_MIME_TYPES.has(mimeType)) {
            downloadFile(fileContent, `${doc_titulo}.${fileExtension}`);
            return;
        }

        const arrayBuffer = base64ToArrayBuffer(fileContent);
        const blob = new Blob([arrayBuffer], { type: mimeType });
        const url = URL.createObjectURL(blob);

        openDocumentModal(url, mimeType);

    } catch (error: any) {
        alert(error?.message || "Erro ao visualizar documento");
    }
};

export const handleDownloadDocument = async (uid_documento: string, fetchDocService: Function) => {
    try {
        const data = await fetchDocService(uid_documento);
        const { doc_titulo, fileContent, fileExtension } = data;

        downloadFile(fileContent, `${doc_titulo}.${fileExtension}`);
    } catch (error: any) {
        alert(error?.message || "Erro ao baixar documento");
    }
};